import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { DeleteTenantDataConfirmationModalComponent } from '../delete-tenant-data-confirmation-modal/delete-tenant-data-confirmation-modal.component';

@Component({
  selector: 'app-delete-tenant-data-modal',
  templateUrl: './delete-tenant-data-modal.component.html',
  styleUrls: ['./delete-tenant-data-modal.component.scss']
})
export class DeleteTenantDataModalComponent implements OnInit {
  @Input() tenantName: string;  
  
  isButtonDisabled: boolean = false;
  isDeleting: boolean = false;
  private modalRef: NgbModalRef;
  
  constructor(private tenantService: TenantService, private router: Router, private modalService: NgbModal, private activeModal: NgbActiveModal) { }

  ngOnInit() { }

  modalOption: NgbModalOptions = {
    backdrop: 'static',
    backdropClass: 'backdrop-confirmation',
    keyboard: false
  };

  onDeleteClientTenantDataButtonClick() {
    this.modalRef  = this.modalService.open(DeleteTenantDataConfirmationModalComponent, this.modalOption);
    this.modalRef.componentInstance.tenantName = this.tenantName;
    this.modalRef.componentInstance.isDeleting = this.isDeleting;
    
    this.modalRef.result.then(result =>{
      if (result) {
        this.deleteDataTenant();
        this.isButtonDisabled = true;      
      }
      else {
        this.onCloseModal();
      }
    });
  }

  deleteDataTenant() {    
    this.isDeleting = true;

    this.tenantService.deleteTenantData(this.tenantName).subscribe(() => {      
      location.reload();
      this.activeModal.close(true);
      return false;      
     });
  }
 
  onCloseModal() {
    let url = `/details/${this.tenantName}`;
    this.router.navigate([url]);
    this.activeModal.close(true);
  }


}
